var _style, _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCargoAllwh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 990.3 726",
    style: {
      enableBackground: "new 0 0 990.3 726"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#FFC10D;}\r\n\t.st2{fill:#194F82;}\r\n\t.st3{fill:none;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M595,53.1c0-8.8-7.2-16-16-16H22c-8.8,0-16,7.2-16,16v400c0,8.8,7.2,16,16,16h41c7.9,0,14.9-5.7,16-13.6 c6.3-48.1,44.7-78,91.1-78c46.4,0,84.8,29.8,91.1,78c1,7.9,8,13.6,16,13.6h275.6c6.6-35.5,21.4-68.2,42.4-95.9V53.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64,84.1h477.8v270.4H64V84.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M473.6,121.8c11.6,0,21.2,7.3,21.2,16.3v173.4c0,8.9-9.5,16.3-21.2,16.3c-11.7,0-21.2-7.3-21.2-16.3V138 C452.4,129.1,462,121.8,473.6,121.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M362.5,121.8c11.6,0,21.2,7.3,21.2,16.3v173.4c0,8.9-9.5,16.3-21.2,16.3c-11.6,0-21.2-7.3-21.2-16.3V138 C341.3,129.1,350.8,121.8,362.5,121.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M250.3,121.8c11.6,0,21.2,7.3,21.2,16.3v173.4c0,8.9-9.5,16.3-21.2,16.3c-11.6,0-21.2-7.3-21.2-16.3V138 C229,129.1,238.6,121.8,250.3,121.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M136.9,121.8c11.6,0,21.2,7.3,21.2,16.3v173.4c0,8.9-9.5,16.3-21.2,16.3c-11.6,0-21.2-7.3-21.2-16.3V138 C115.8,129.1,125.2,121.8,136.9,121.8z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 170,
    cy: 475.8,
    r: 20
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M824.4,242.9l-66.7-80c-3-3.6-7.5-5.8-12.3-5.8H675c-8.8,0-16,7.2-16,16v80c0,8.8,7.2,16,16,16h137.1 C825.7,269.1,833.1,253.3,824.4,242.9z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M907,324v-26.9c0-3.8-1.3-7.4-3.7-10.3l-130.5-156c-3-3.6-7.5-5.7-12.3-5.7H643c-8.8,0-16,7.2-16,16V339 c40-34.9,92.3-56,149.6-56C825.1,283,870.1,298.1,907,324z M659,253.1v-80c0-8.8,7.2-16,16-16h70.5c4.7,0,9.2,2.1,12.3,5.8l66.7,80 c8.7,10.4,1.3,26.2-12.3,26.2H675C666.2,269.1,659,261.9,659,253.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170,407.8c-37.5,0-68,30.5-68,68c0,37.5,30.5,68,68,68c37.5,0,68-30.5,68-68C238,438.3,207.5,407.8,170,407.8z  M170,495.8c-11,0-20-9-20-20s9-20,20-20s20,9,20,20S181,495.8,170,495.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M778.4,310.5C665,310.5,573,402.6,573,516s92,205.4,205.4,205.4s205.4-92,205.4-205.4S891.8,310.5,778.4,310.5z  M778.4,663.9c-51.4,0-96.8-26.3-123.3-66.1c0.6-40.9,82.2-63.3,123.3-63.3c40.9,0,122.6,22.4,123.3,63.3 C875.2,637.6,829.8,663.9,778.4,663.9z M716.8,433.8c0-34.1,27.5-61.6,61.6-61.6c34.1,0,61.6,27.5,61.6,61.6s-27.5,61.6-61.6,61.6 C744.3,495.4,716.8,467.9,716.8,433.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCargoAllwh);
export default __webpack_public_path__ + "static/media/cargo-allwh.499f9ddca64b5b9d37e812e75332373a.svg";
export { ForwardRef as ReactComponent };